import React from 'react';
import ReactDOM from 'react-dom';
import "./styles/bootstrap.min.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// Load environment variables based on runtime environment
if (process.env.NODE_ENV === 'development') {
  require('dotenv').config({ path: '.env.local' });
} else if (process.env.NODE_ENV === 'production') {
  require('dotenv').config({ path: '.env.development' });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
